import { tokenRefs } from "./tokens";

const { surface, colors } = tokenRefs;

export const thirdPartyStyles = {
  ".fc": {
    "--fc-page-bg-color": surface.base,
    "--fc-neutral-bg-color": surface.sunken,
    "--fc-neutral-text-color": surface.textSecondary,
    "--fc-border-color": surface.border,
    "--fc-today-bg-color": surface.selected,
    "--fc-highlight-color": surface.selected,
    "--fc-list-event-hover-bg-color": surface.hover,
    "--fc-non-business-color": surface.sunken,
    color: surface.text,
  },
  ".fc .fc-toolbar-title, .fc .fc-col-header-cell-cushion, .fc .fc-daygrid-day-number": {
    color: surface.text,
  },
  ".fc .fc-button": {
    backgroundColor: surface.sunken,
    borderColor: surface.border,
    color: surface.text,
  },
  ".fc .fc-button-primary:not(:disabled).fc-button-active, .fc .fc-button-primary:not(:disabled):active": {
    backgroundColor: colors.orange.base,
    borderColor: colors.orange.base,
    color: "#FFFFFF",
  },
  ".fc .fc-daygrid-day.fc-day-other .fc-daygrid-day-top": { opacity: 0.45 },
  ".react-resizable-handle": { filter: "var(--fx-icon-filter, none)" },
  ".gjs-one-bg, .gjs-two-color, .gjs-editor": { colorScheme: "dark" },
  ".pac-container": {
    backgroundColor: surface.overlay,
    borderColor: surface.border,
    color: surface.text,
  },
  ".pac-item": { borderColor: surface.border, color: surface.textSecondary },
  ".pac-item:hover, .pac-item-selected": { backgroundColor: surface.hover },
  ".pac-item-query, .pac-matched": { color: surface.text },
  "lk-room-container, [data-lk-theme]": { colorScheme: "dark" },
} as const;

export const iconFilterByMode = {
  light: "none",
  dark: "invert(1) hue-rotate(180deg)",
} as const;
